import React, { useState } from "react"
import axios from "axios"
import { navigate } from "gatsby"
import InnerWrapper from "./innerWrapper"
import styles from "./scss/contact.module.scss"

const Contact = () => {
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [failure, setFailure] = useState(false)

  const handleSubmit = evt => {
    evt.preventDefault()
    setLoading(true)
    const axiosConfig = {
      header: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }
    axios
      .post(
        "/.netlify/functions/sendEmail",
        {
          name,
          email,
          message,
        },
        axiosConfig
      )
      .then(() => {
        setName("")
        setEmail("")
        setMessage("")
        navigate("/thank-you")
        setLoading(false)
      })
      .catch(() => {
        setFailure(true)
        setTimeout(() => {
          setFailure(false)
        }, 5000)
      })
  }

  const handleChange = evt => {
    const { name, value } = evt.target
    if (name === "name") {
      setName(value)
    } else if (name === "email") {
      setEmail(value)
    } else if (name === "message") {
      setMessage(value)
    }
  }

  return (
    <section className={styles.contact} id="contact">
      <InnerWrapper width={800}>
        <h2>Get in touch</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            name="name"
            id="name"
            value={name}
            required
            onChange={handleChange}
          />
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            id="email"
            required
            value={email}
            onChange={handleChange}
          />
          <label htmlFor="message">Your message</label>
          <textarea
            name="message"
            id="message"
            cols="30"
            rows="10"
            required
            value={message}
            onChange={handleChange}
          />
          <button className="button" type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
          {failure && (
            <div className={styles.infoMessage}>
              There was an error submitting your message. Please try again.
            </div>
          )}
        </form>
      </InnerWrapper>
    </section>
  )
}

export default Contact
